import { config } from "../../config";
import axios from  'axios' ; 
import store from '../store/index'

const loadingWrapper = async (callback) => {
    var res = null ; 
    store.commit("setIsLoading",true)
    res =  await callback() ; 
    store.commit("setIsLoading",false)
    return res ; 
 }

export class ReportingAndAnalyticsService {

    static async getDataExtractReport(startDate , endDate , raceCourse , raceNumber ){
        return await loadingWrapper(async () => {
            var data =  await axios.get(`${config.reportingURL}/api/Reports?startDate=${startDate}&endDate=${endDate}&rc=${raceCourse}&rn=${raceNumber}`)
            return data.data ; 
        })      
    }

    static async getReportSectionalData(startDate , racecourse , rn){
        return await loadingWrapper(async () => {
            var data  = await  axios.get(`${config.reportingURL}/api/Reports/Sectional?startTime=${startDate}&rc=${racecourse}&rn=${rn}`)
            return data.data ; 
        });
    }

    static async getReportPositionBehindFilterScreen(startDate , raceCourse){
        return await loadingWrapper(async() => {
            var data = await axios.get(`${config.reportingURL}/api/Reports/FilterPositionBehindRaces?startTime=${startDate}&rc=${raceCourse}`) ; 
            return data.data ; 
        })     
    }

    static async getReportPostionBehind(startDate,raceCourse,raceNumber){
        return await loadingWrapper(async  () => {
            var data = await axios.get(`${config.reportingURL}/api/Reports/PositionBehind?startTime=${startDate}&rc=${raceCourse}&rn=${raceNumber}`) ; 
            return data.data ;
        })      
    }

    static async getReportSectionalPosition(startDate,raceCourse,rn){
       return await loadingWrapper(async () =>{
            var data = await  axios.get(`${config.reportingURL}/api/Reports/SectionalPosition?startTime=${startDate}&rc=${raceCourse}&rn=${rn}`)
            return data.data ; 
       })
    }

    static async getReportSectionalKMH(startDate,raceCourse,rn){
        return await loadingWrapper(async () => {
            var data = await  axios.get(`${config.reportingURL}/api/Reports/SectionalKMH?startTime=${startDate}&rc=${raceCourse}&rn=${rn}`)
            return data.data ; 
        })
    }

    static async getReportSectionalDistanceCovered(startDate,raceCourse,rn){
        return await loadingWrapper(async() => {
            var data = await  axios.get(`${config.reportingURL}/api/Reports/DistanceCovered?startTime=${startDate}&rc=${raceCourse}&rn=${rn}`)
            return data.data ; 
        })
    }

    static async getRaceCourseForDisplay(){
        return await loadingWrapper(async() => {
            var data  =  await axios.get(`${config.reportingURL}/api/Reports/RaceCourses`) ; 
             return data.data ; 
        })
    }
    static async getPostionAndTimeReport(startDate,raceCourse,raceNumber){
        return await loadingWrapper(async() => {
            var data = await axios.get(`${config.reportingURL}/api/Reports/PositionAndTimePerSectorReport?raceCourse=${raceCourse}&startDate=${startDate}&raceNumber=${raceNumber}`);
            return data.data ; 
        })
    }
    static async getSectionsToFinishReport(startDate, raceCourse , raceNumber){
       return await loadingWrapper(async() =>{
            var data = await axios.get(`${config.reportingURL}/api/Reports/GetSectionToFinish?rc=${raceCourse}&StartDate=${startDate}&rn=${raceNumber}`)
            return data.data
       })
    }

    static async getRunningPositionAndMarginBehindLeader(startDate,raceCourse , raceNumber){
       return await loadingWrapper(async() =>{
            var data = await axios.get(`${config.reportingURL}/api/Reports/RunningPositionAndMarginBehindLeader?StartDate=${startDate}&rc=${raceCourse}&rn=${raceNumber}`)
            return data.data
       })
    }

    static async getSectionalTimeRank(startDate, raceCourse, raceNumber){
        return await loadingWrapper(async() => {
            var data = await axios.get(`${config.reportingURL}/api/Reports/GetSectionalTimeRank?startDate=${startDate}&rc=${raceCourse}&rn=${raceNumber}`);
            return data.data
        })
    }
}